import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "data-plans-item-head-group" }
const _hoisted_2 = { class: "data-plans-item-head" }
const _hoisted_3 = { class: "gb-info" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "price-main-row" }
const _hoisted_6 = { class: "price-main" }
const _hoisted_7 = { class: "b-info-gb" }
const _hoisted_8 = {
  key: 0,
  class: "b-info__recommended"
}

import { PropType } from "vue";
import BundleCountries from "@/components/bundle/BundleCountries.vue";
import { Bundle, useBundleStore } from "@/stores/bundle";
import { Country } from "@/stores/data";
import router from "@/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'BundleCard',
  props: {
  bundle: Bundle,
  requestedCountries: Array as PropType<Array<Country>>,
  primary: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const bundleStore = useBundleStore();

const goBundleDetails = () => {
  bundleStore.addBundle(props.bundle);
  router.push(
    `/bundle/${props.bundle?.id}?requestedCountries=${JSON.stringify(
      props.requestedCountries?.map((c) => c.iso)
    )}`
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["data-plans-slider-item", { primary: __props.primary, filled: __props.bundle?.primary }]),
    onClick: goBundleDetails
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.bundle.dataAmountGb()) + " GB " + _toDisplayString(__props.bundle.duration) + " days ", 1),
        (__props.bundle?.primary)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createTextVNode(" Regional plan: "),
              _createElementVNode("b", null, _toDisplayString(__props.bundle.countries.length), 1),
              _createTextVNode(" " + _toDisplayString(__props.bundle.countries.length > 1 ? "countries" : "country"), 1)
            ]))
          : _createCommentVNode("", true),
        (!__props.bundle?.primary)
          ? (_openBlock(), _createBlock(BundleCountries, {
              key: 1,
              countries: __props.bundle?.countries || [],
              "requested-countries": __props.requestedCountries || []
            }, null, 8, ["countries", "requested-countries"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (__props.bundle?.primary)
          ? (_openBlock(), _createBlock(BundleCountries, {
              key: 0,
              countries: __props.bundle?.countries || [],
              "requested-countries": __props.requestedCountries || [],
              "show-max-countries-length": 3
            }, null, 8, ["countries", "requested-countries"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_6, " $" + _toDisplayString(__props.bundle.priceUsd()), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (__props.primary)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Recommended plan"))
        : _createCommentVNode("", true),
      (__props.bundle)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "view-btn",
            onClick: goBundleDetails
          }, " View offer "))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})